import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';

export interface DialogData {
  id: string;
  userid: number;
}

@Component({
  selector: 'app-siteloader',
  templateUrl: './siteloader.component.html',
  styleUrls: ['./siteloader.component.scss']
})
export class SiteloaderComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SiteloaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public translate: TranslateService,
    public langservice: LanguageService) {
      dialogRef.disableClose = true;
      translate.addLangs(['en', 'fr', 'hi']);
      if (this.langservice.setlang) {
        translate.setDefaultLang(this.langservice.setlang);
      }
      else {
        translate.setDefaultLang('en');
      }
     }

  ngOnInit() {
  }

}
